import { createSelector } from 'reselect';
import {
  dataSelector,
  geographySelector,
  rangeBreaksSelector,
} from 'selectors/indicator';
import { timeframeLatest } from 'selectors/indicator/timeframe';
import { map as mapColors, noData } from 'config/colors';
import { stateMap } from 'config/mapConfig';
import { sta } from 'config/stateLookup';
import { organizeData } from 'services/breakAndOrganizeData';

const generateStateMapData = (
  data,
  geographies,
  latest,
  rangeBreaks,
  { timeframe: activeTimeframe = latest.value } = {}
) => {
  const filteredData = data.filter(({ timeframe: { value }, geography }) =>
    activeTimeframe === value && 'US' !== geographies[geography].code);

  const { buckets, data: organizedData } =
    organizeData(rangeBreaks, filteredData, true);

  const dataClasses = buckets.map(({ idx, min, max }) => ({
    color: mapColors[idx],
    from: max,
    to: min,
  }));

  const retData = organizedData.map(({
    geography,
    bucket,
    value,
    ...state
  }) => ({
    ...state,
    name: geographies[geography].geography,
    bucket,
    fips: parseInt(geographies[geography].code, 10),
    shortName: sta[geographies[geography].geography],
    value,
    color: 'n/a' !== value ? mapColors[bucket] : noData,
  }));

  return {
    ...stateMap,
    colorAxis: {
      dataClasses,
    },
    series: [{
      borderColor: '#FFFFFF',
      data: retData,
      mapData: stateMap.mapData,
      joinBy: ['state-fips', 'fips'],
      dataLabels: {
        enabled: true,
        format: '{point.shortName}',
      },
    }],
  };
};

export default createSelector(
  dataSelector,
  geographySelector,
  timeframeLatest,
  rangeBreaksSelector,
  (state, ownProps) => ownProps,
  generateStateMapData
);



// WEBPACK FOOTER //
// ./app/selectors/indicator/maps/states.js